import RegistrationUserCompanyAdmin from './RegistrationUserCompanyAdmin';

export default RegistrationUserCompanyAdmin;
